// extracted by mini-css-extract-plugin
export default {"Comment":"styles_Comment__BNmP8","Button":"styles_Button__2kI5V"};